import { isValidLocale } from '../locale-validation'
import type { Locale } from '../types/locale'

export const getLocaleFromPathname = (pathname: string): Locale => {
  const locale = pathname.split('/').find(Boolean) ?? ''
  if (!isValidLocale(locale)) {
    throw new Error(`Invalid locale: ${locale}`)
  }
  return locale
}

/**
 * The pathname's locale prefix, or `undefined` when it has none. Use this
 * instead of {@link getLocaleFromPathname} on a surface that is not
 * locale-prefixed — the Custom Made configurator is served from
 * `/configurator`, where the throwing variant took down Avo init and every
 * Segment enrichment call with it.
 */
export const getOptionalLocaleFromPathname = (
  pathname: string,
): Locale | undefined => {
  const locale = pathname.split('/')[1] ?? ''
  return isValidLocale(locale) ? locale : undefined
}
